module.exports = __webpack_public_path__ + "media/Video 25.479ff830.mp4";